<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div
      id="cancelSubLicence"
      class="modal fade"
      :class="{ show: modalState.show }"
      style="background: rgba(0,0,0,0.5)"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" id="modal">
          <div class="card-body">
            <h5
              class="mx-0 px-2 pb-3"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <!-- {{ $t("add_user") }} -->
              {{ modalState.header }}
            </h5>

            <p>
  {{ $t('turn-off-action', { type: modalState.type }) }}
</p>
<br />
<ul>
  <li class="mb-3">{{ $t('no-longer-use-plan') }}</li>
  <li>{{ $t('no-longer-subscribed') }}</li>
</ul>
<br />
<p>{{ $t('continue-question') }}</p>
            <div
              class="form-group mt-5"
              style="display:flex; justify-content: space-between"
            >
              <button @click="onCancel" type="button" class="btn btn-secondary">
                {{ $t("cancel") }}
              </button>
              <button
                type="button"
                @click="handleSubmit"
                class="btn"
                style="background:#FD4D4D;border:0;color:white"
              >
                <!-- {{ $t("Yes, Turn Off this Licence") }} -->
                Yes {{ modalState.cancelBtn }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import * as intlTelInput from "../../assets/js/intlTelInput";
import * as utils from "../../assets/js/utils";

export default {
  name: "CancelSub",
  props: {
    // show: Boolean,
    // type: String,
    modalState: Object,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      fullname: "",
      email: "",
      role: "staff",
      mssg: "",
      ErrorPhone: "",
      Errormssg: "",
      iti: "",
      selectNotification: "",
    };
  },
  components: {
    Loading,
  },
  mounted() {
    setTimeout(() => {
      var input = document.querySelector("#phone_number");
      this.iti = intlTelInput(input, {
        separateDialCode: true,
        utilsScript: utils,
      });
      this.iti.setCountry("ng");
    }, 200);
    console.log(this.modalState);
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters([]),
  },
  methods: {
    ...mapActions([
      "addUser",
      "getUsers",
      "getActiveSubscribedDevices",
      "doTurnOff",
      "doCancelSub",
      "getSubscriptions",
      "updateSucMsg",
      "updateErrMsg",
    ]),
    onCancel() {
      this.$emit("closeCancelModal");
    },
    handleSubmit() {
      const { isLicence, id } = this.modalState;
      if (!isLicence) {
        this.isLoading = true;
        this.doTurnOff(id)
          .then((res) => {
            this.onCancel();
            this.getActiveSubscribedDevices().then(() => {
              this.isLoading = false;
            });
            this.updateSucMsg(
              res.data.message[0].toUpperCase() + res.data.message.slice(1)
            );
            setTimeout(() => {
              this.updateSucMsg("");
            }, 3000);
          })
          .catch((error) => {
            this.isLoading = false;
            // error.response can be null
            this.updateErrMsg(
              error.response.data.message[0].toUpperCase() +
                error.response.data.message.slice(1)
            );
            setTimeout(() => {
              this.updateErrMsg("");
            }, 3000);
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      } else {
        this.isLoading = true;
        this.doCancelSub(id)
          .then((res) => {
            this.onCancel();
            this.getSubscriptions().then(() => {
              this.isLoading = false;
            });
            this.updateSucMsg(
              res.data.message[0].toUpperCase() + res.data.message.slice(1)
            );
            setTimeout(() => {
              this.updateSucMsg("");
            }, 3000);
          })
          .catch((error) => {
            this.isLoading = false;
            this.updateErrMsg(
              error.response.data.message[0].toUpperCase() +
                error.response.data.message.slice(1)
            );
            setTimeout(() => {
              this.updateErrMsg("");
            }, 3000);
            // error.response can be null
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      }
    },
  },
  //   watch: {
  //     fullname: {
  //       handler() {
  //         if (/^[a-zA-Z\s]*$/.test(this.fullname))
  //           return (this.selectNotification = "");
  //         else this.selectNotification = this.$t("must_contain");
  //       },
  //     },
  //   },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 500px !important;
}
button:focus {
  outline: none;
  border: none;
}
</style>
<i18n>
{
	"en": {
		"add_user": "Add a User",
		"all_users": "All Users",
		"continue-question": "Are you sure you want to continue?",
		"edit_user": "Edit User",
		"email": "Email",
		"full_name": "Full Name",
		"man_user_right": "Manage user rights for members of your business",
		"manage": "Manager",
		"must_contain": "Must conain only Letters",
		"name": "Name",
		"no-longer-subscribed": "You will no longer be subscribed to the plan",
		"no-longer-use-plan": "You will no longer be able to use the plan",
		"phone": "Phone Number",
		"staff": "Staff",
		"turn-off-action": "This action will turn off this {{ type }} plan. This means that:",
		"user_rights": "User Rights",
		"valid_phone": "This phone number is not valid"
	},
	"fr": {
		"add_user": "Ajouter un utilisateur",
		"all_users": "Tous les utilisateurs",
		"continue-question": "Es-tu sur de vouloir continuer?",
		"edit_user": "Modifier l'utilisateur",
		"email": "E-mail",
		"full_name": "Nom et prénom",
		"man_user_right": "Gérez les droits d'utilisation des membres de votre entreprise",
		"manage": "Directeur",
		"must_contain": "Ne doit contenir que des lettres",
		"name": "Nom",
		"no-longer-subscribed": "Vous ne serez plus abonné au plan",
		"no-longer-use-plan": "Vous ne pourrez plus utiliser le plan",
		"phone": "Numéro de téléphone",
		"staff": "Personnel",
		"turn-off-action": "Cette action désactivera ce forfait {{ type }} . Cela signifie que:",
		"user_rights": "Droits de l'utilisateur",
		"valid_phone": "Ce numéro de téléphone n'est pas valide"
	},
	"sw": {
		"add_user": "ONGEZA MTUMIAJI",
		"all_users": "Watumiaji Wote",
		"continue-question": "Je, una uhakika ungependa kuendelea?",
		"edit_user": "Badilisha mtumiaji",
		"email": "Barua pepe",
		"full_name": "Jina kamili",
		"man_user_right": "Dhibiti haki za mtumiaji za wanachama wa biashara yako",
		"manage": "Meneja",
		"must_contain": "Lazima iwe na Barua tu",
		"name": "Jina",
		"no-longer-subscribed": "Hutasajiliwa tena kwa mpango",
		"no-longer-use-plan": "Hutaweza tena kutumia mpango",
		"phone": "Nambari ya simu",
		"staff": "STAFF",
		"turn-off-action": "Kitendo hiki kitazima mpango huu {{ type }} . Hii ina maana kwamba:",
		"user_rights": "Haki za Mtumiaji",
		"valid_phone": "Nambari hii ya simu si sahihi"
	}
}
</i18n>
